// extracted by mini-css-extract-plugin
export var active = "_r-9";
export var backButton = "_r-8";
export var clone = "_r-e";
export var collapseBar = "_r-k";
export var collapseMode = "_r-m";
export var collapsed = "_r-o";
export var dimmed = "_r-i";
export var dragHandle = "_r-c";
export var dropdownIcon = "_r-g";
export var expanding = "_r-n";
export var hidden = "_r-x";
export var iconContainer = "_r-q";
export var iconSwapper = "_r-w";
export var navItem = "_r-6";
export var navItemIcon = "_r-f";
export var navProfile = "_r-7";
export var notificationCountBadge = "_r-j";
export var notificationDot = "_r-r";
export var optionsContainer = "_r-h";
export var primaryNav = "_r-0";
export var primaryNavDivider = "_r-v";
export var primaryNavResizeHandle = "_r-2";
export var primaryNavResizing = "_r-1";
export var primaryNavTabSection = "_r-u";
export var primaryTab = "_r-p";
export var primaryTabIconBox = "_r-s";
export var secondaryNav = "_r-3";
export var selected = "_r-t";
export var settingsNav = "_r-4";
export var settingsNavItems = "_r-5";
export var show = "_r-d";
export var sideNav = "_r-l";
export var teamItem = "_r-a";
export var userProfileItem = "_r-b";